import { useMeterDataQuery } from "@core/apis/shared/hooks";

import { useFormattedEnergyData } from "./useFormattedEnergyData";
import type { NonNullableDateRange } from "./useGraphControlState";
import { useRadiatorCurveData } from "./useRadiatorCurveData";

const ENERGY_COMPONENTS = ["heat_energy", "returntemp", "supplytemp"] as const;

export function useEnergyChartData(
  substationId: string,
  dateRange: NonNullableDateRange,
  options?: { networkUid?: string }
) {
  const { data: rawMeterData, isLoading: meterDataLoading } = useMeterDataQuery(
    substationId,
    [...ENERGY_COMPONENTS],
    dateRange.startDate,
    dateRange.endDate,
    options
  );

  const {
    sensors: radiatorSensors = [],
    sensorDataByUid: radiatorSensorData = {},
    sensorDataLoading: radiatorSensorDataLoading,
    weatherData: outdoorData = [],
    weatherLoading: outdoorDataLoading,
  } = useRadiatorCurveData({
    substationId,
    networkUid: options?.networkUid,
    dateRange: { start: dateRange.startDate, end: dateRange.endDate },
    sensorTypes: ["radiator_system_supply_temp"],
    includeRadiatorCurves: false,
  });

  const { data, isLoading } = useFormattedEnergyData({
    rawMeterData,
    meterDataLoading,
    radiatorSensors,
    radiatorSensorData,
    radiatorSensorDataLoading,
    weatherData: outdoorData,
    weatherLoading: outdoorDataLoading,
  });

  return { data, isLoading, isEmpty: !isLoading && data.length === 0 };
}
